import {
  AVAILABILITY_AVAILABLE,
  AVAILABILITY_BROKEN,
  AVAILABILITY_LOST,
  AVAILABILITY_REFORMED,
  AVAILABILITY_UNAVAILABLE,
  AVAILABILITY_TESTING,
} from '@constants/tracker/availability.js'

export const availabilityTag = {
  [AVAILABILITY_AVAILABLE]: { label: 'Rendu', type: 'is-light is-success' },
  [AVAILABILITY_UNAVAILABLE]: {
    label: 'Non rendu',
    type: 'is-light is-warning',
  },
  [AVAILABILITY_LOST]: { label: 'Perdu', type: 'is-light is-danger' },
  [AVAILABILITY_BROKEN]: { label: 'Cassé', type: 'is-light is-danger' },
  [AVAILABILITY_REFORMED]: { label: 'Réformé', type: 'is-light is-dark' },
  [AVAILABILITY_TESTING]: { label: 'En test', type: 'is-light is-info' },
}
